export const environment = {
  production: true,
  imUrl: 'https://im.promen.me/',
  walletUrl: 'https://bill.anmei.me',
};
